import React, { useEffect, useState } from 'react';
import { Switch, Tooltip } from 'antd';
import { map, get, isEmpty } from 'lodash';
import { bool, func, object, array } from 'prop-types';
import { withApollo } from 'react-apollo';
import { FlexContainer, Row, Button, Icon, Text, Drawer, FormInput, Loading } from '../../common';
import CREATE_EXTERNAL_ISSUE from '../../../queries/CREATE_EXTERNAL_ISSUE';
import UPDATE_EXTERNAL_ISSUE from '../../../queries/UPDATE_EXTERNAL_ISSUE';
import { GREEN_DARK } from '../../../utils/colors';
import './external-factors.css';

const MotivesDrawer = ({ registerMotivesDrawer, handleRegisterMotivesDrawer, client, motives, refetchMotives }) => {
    const [showForm, setShowForm] = useState(false);
    const [name, setName] = useState('');
    const [comment, setComment] = useState('');
    const [status, setStatus] = useState(false);
    const [loading, setLoading] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const [issueToEdit, setIssueToEdit] = useState({ id: null });

    const handleStatus = (value) => {
        setStatus(value);
    };

    useEffect(() => {
        if (!registerMotivesDrawer) {
            setIssueToEdit(false);
            setShowForm(false);
        }
    }, [registerMotivesDrawer]);

    const onSubmit = async () => {
        setLoading(true);
        if (!isEditing) {
            await client.mutate({
                mutation: CREATE_EXTERNAL_ISSUE,
                variables: { input: {
                    name,
                    comment,
                    isActive: status
                } },
                refetchQueries: ['getExternalIssues']
            }).then(async () => {
                await refetchMotives();
                setLoading(false);
                setShowForm(false);
            });
        } else {
            await client.mutate({
                mutation: UPDATE_EXTERNAL_ISSUE,
                variables: { input: {
                    id: get(issueToEdit, 'id'),
                    name,
                    comment,
                    isActive: status
                } },
                refetchQueries: ['getExternalIssues']
            }).then(async () => {
                await refetchMotives();
                setIsEditing(false);
                setLoading(false);
                setIssueToEdit(null);
            });
        }
    };

    const renderSaveOrCancel = () => {
        const isDataComplete = !(isEmpty(name) || isEmpty(comment));

        return <Row gap={12} justify='center'>
            {loading
                ? <Loading loading={loading} />
                : <>
                    <Tooltip title='Cancelar'>
                        <a style={{ marginTop: 5 }}>
                            <Icon
                                name='new-cross'
                                size={25}
                                color='#CC444B'
                                onClick={() => {
                                    setIssueToEdit(null);
                                    setIsEditing(false);
                                    setShowForm(false);
                                }}
                            />
                        </a>
                    </Tooltip>
                    <Tooltip title='Guardar'>
                        <a style={{ marginTop: 5 }}>
                            <Icon
                                name='new-check'
                                size={25}
                                color={isDataComplete ? GREEN_DARK : 'grey'}
                                style={{ opacity: isDataComplete ? 1 : 0.5 }}
                                onClick={() => isDataComplete && onSubmit()}
                            />
                        </a>
                    </Tooltip>
                </>}
        </Row>;
    };

    const renderActions = (issue, isEditingIssue) => {
        return <>
            {isEditingIssue
                ? renderSaveOrCancel()
                : <Tooltip title='Editar'>
                    <a style={{ marginTop: 5 }}>
                        <Icon
                            name='pencil-edit'
                            size={23}
                            color={GREEN_DARK}
                            onClick={() => {
                                setIsEditing(true);
                                setName(get(issue, 'name'));
                                setComment(get(issue, 'comment'));
                                setIssueToEdit({ id: get(issue, 'id') });
                            }}
                        />
                    </a>
                </Tooltip>
            }
        </>;
    };

    const formIssue = () => {
        return <>
            <div className='cell large-cell'>
                <FormInput
                    onChange={({ target }) => setName(target.value)}
                    width='100%'
                    value={name}
                    style={{ margin: 0 }}
                    placeholder='Ingresa nombre motivo'
                />
            </div>
            <div className='cell normal-cell'>
                <FormInput
                    onChange={({ target }) => setComment(target.value)}
                    style={{ margin: 0 }}
                    width='100%'
                    value={comment}
                    placeholder='Ingresa observación'
                />
            </div>
        </>;
    };

    return (
        <Drawer
            destroyOnClose
            values={['60%', '60%', '100%']}
            title={<Text size={20} text='Agregar y editar motivos' />}
            closable
            visible={registerMotivesDrawer}
            onClose={handleRegisterMotivesDrawer}
        >
            <FlexContainer justify='flex-end' pB={15}>
                <Button onClick={() => {
                    setName('');
                    setComment('');
                    setIssueToEdit(null);
                    setShowForm(true);
                    setIsEditing(false);
                }} width={200}>
                    <Row align='center' gap={7}>
                        <Icon name='new-plus' size={15} color='#ffffff' />
                        Agregar motivo
                    </Row>
                </Button>
            </FlexContainer>
            <div style={{ overflowX: 'auto' }}>
                <div className='table-card'>
                    <div className='header-card'>
                        <div className='cell large-cell'>Motivo</div>
                        <div className='cell normal-cell'>Observación</div>
                        <div className='cell small-cell'>Estado</div>
                        <div className='cell small-cell'>
                            Acciones
                        </div>
                    </div>
                    {(showForm && !isEditing) && <div className='row-card'>
                        {formIssue()}
                        <div className='cell small-cell'>
                            {renderSaveOrCancel()}
                        </div>
                    </div>}
                    {map((motives), item => {
                        const isEditingIssue = get(issueToEdit, 'id') === get(item, 'id');

                        return <div className='row-card' key={get(item, 'id')}>
                            {isEditingIssue
                                ? formIssue()
                                : <>
                                    <div className='cell large-cell'>{get(item, 'name')}</div>
                                    <div className='cell normal-cell'>{get(item, 'comment')}</div>
                                </>
                            }
                            <div className='cell small-cell'>
                                {<Switch defaultChecked={get(item, 'isActive')} disabled={!isEditingIssue} onChange={(value) => {
                                    isEditing && handleStatus(value);
                                }} />}
                            </div>
                            <div className='cell small-cell'>
                                {renderActions(item, isEditingIssue)}
                            </div>
                        </div>;
                    })}
                </div>
            </div>
        </Drawer>
    );
};

MotivesDrawer.propTypes = {
    registerMotivesDrawer: bool,
    handleRegisterMotivesDrawer: func,
    client: object,
    refetchMotives: func,
    motives: array
};

export default withApollo(MotivesDrawer);
